"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    getUsersReviews: {
        url: "/users/{uid}/reviews",
        method: "GET",
    },
    addReviewEmployer: {
        url: "/jobs/{jid}/author/reviews",
        method: "POST",
    },
    addReviewCandidate: {
        url: "/applications/{aid}/candidate/reviews",
        method: "POST",
    },
    getMyReviews: {
        url: "/me/reviews",
        method: "GET",
    },
    getPendingReviews: {
        url: "/reviews/pending",
        method: "GET",
    },
};
//# sourceMappingURL=reviews.js.map